/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByLanguageKind = (typeof GroupByLanguageKind)[keyof typeof GroupByLanguageKind];

export const GroupByLanguageKind = {
  language: 'language',
} as const;
